import { render, staticRenderFns } from "./Letrix.vue?vue&type=template&id=d5f559c2&scoped=true&"
import script from "./Letrix.vue?vue&type=script&lang=js&"
export * from "./Letrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f559c2",
  null
  
)

export default component.exports